<template>
  <div class="modal__wrapper">
    <div class="modal__close">
      <div class="btn" @click="close">
        <Close class="img"/>
      </div>
    </div>
    <div class="modal__header">
      <div class="ttl">Internal contact</div>
    </div>
    <div class="modal__body">
      <div class="row">
        <div class="label">Approve to License List</div>
        <div class="data c-tmblr" :disabled="form.business_offer_id">
          <Tmblr :active="!!form.approve_to_list" :class="'c-tmblr'" :text="'Approve to License List'" @changeState="changeState('approve_to_list')" />
        </div>
      </div>
      <div class="row">
        <div class="label">Approve to Legal Providers List</div>
        <div class="data c-tmblr" :disabled="form.legal_service_id">
          <Tmblr :active="!!form.approve_to_legal_services_list" :class="'c-tmblr'" :text="'Approve to Legal Providers'" @changeState="changeState('approve_to_legal_services_list')" />
        </div>
      </div>
      <div class="row">
        <div class="label">Is Top</div>
        <div class="data c-tmblr">
          <Tmblr :active="!!form.is_top" :class="'c-tmblr'" :text="'Is Top'" @changeState="changeState('is_top')" />
        </div>
      </div>
      <div class="row">
        <div class="label">Managers</div>
        <div class="data">
          <div v-for="(formManager, formManagerIndex) in form.managers">
            <div>
              <div class="row">
                <div class="data">
                  <div class="row">
                    <div class="label">
                      Manager № {{ formManagerIndex + 1 }}
                    </div>
                    <div class="data">
                      <div class="delete-btn" @click="deleteManager(formManagerIndex)">
                        <Close class="img"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <select name="manager_name" class="inpt" v-model="formManager.name">
                <option :value="null">Select manager</option>
                <option 
                  v-for="(manager, i) in managers" 
                  :value="manager.name"
                >
                  {{ manager.name }}
                </option>
              </select>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="data">
                <span class="btn" @click="addManager">
                  Add manager
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="label">Status</div>
        <div class="data">
          <select name="priority" class="inpt" v-model="form.status">
            <option :value="null">Select status</option>
            <option
              v-for="status in statuses" :key="status"
              :selected="status === form.status"
              :value="status"
            >
              {{ status }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="label">Country</div>
        <div class="data">
          <select name="country_id" class="inpt" v-model="form.country_id">
            <option :value="null">Select country</option>
            <option
              v-for="country in countries" :key="country.id"
              :selected="country.id === form.country_id"
              :value="country.id"
            >
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="label">Company name</div>
        <div class="data">
          <input type="text" name="company_name" class="inpt" v-model="form.company_name" placeholder="Company Name">
        </div>
      </div>
      <div class="row">
        <div class="label">Service Type</div>
        <div class="data">
          <input type="text" name="service_type" class="inpt" v-model="form.service_type" placeholder="Service Type">
        </div>
      </div>
      <div class="row">
        <div class="label">Provider Type</div>
        <div class="data">
          <input type="text" name="provider_type" class="inpt" v-model="form.provider_type" placeholder="Provider Type">
        </div>
      </div>
      <div class="row">
        <div class="label">Channel</div>
        <div class="data">
          <input type="text" name="channel" class="inpt" v-model="form.channel" placeholder="Channel/AI">
        </div>
      </div>
      <div class="row">
        <div class="label">Web site</div>
        <div class="data">
          <input type="text" name="web_site" class="inpt" v-model="form.web_site" placeholder="Web Site Link">
        </div>
      </div>
      <div class="row">
        <div class="label">Contact Data</div>
        <div class="data">
          <input type="text" name="contact_data" class="inpt" v-model="form.contact_data" placeholder="Contact Data">
        </div>
      </div>
      <div class="row">
        <div class="label">Second Contact Person</div>
        <div class="data">
          <input type="text" name="other_contact_person" class="inpt" v-model="form.other_contact_person" placeholder="Second Contact Person">
        </div>
      </div>
      <div class="row">
        <div class="label">Email</div>
        <div class="data">
          <input type="text" name="email" class="inpt" v-model="form.email" placeholder="Email">
        </div>
      </div>
      <div class="row">
        <div class="label">LinkedIn</div>
        <div class="data">
          <input type="text" name="linkedin" class="inpt" v-model="form.linkedin" placeholder="LinkedIn">
        </div>
      </div>
      <div class="row">
        <div class="label">Price</div>
        <div class="data">
          <input type="text" name="price" class="inpt" v-model="form.price" placeholder="Price">
        </div>
      </div>
      <div class="row">
        <div class="label">Price Note</div>
        <div class="data">
          <input type="text" name="price_note" class="inpt" v-model="form.price_note" placeholder="Price Note">
        </div>
      </div>
      <div class="row">
        <div class="label">First Message Status</div>
        <div class="data">
          <input type="text" name="first_message_status" class="inpt" v-model="form.first_message_status" placeholder="First Message Status">
        </div>
      </div>
      <div class="row">
        <div class="label">First Call Date</div>
        <div class="data">
          <input type="date" name="first_call_date" class="inpt" v-model="form.first_call_date" placeholder="First Call Date">
        </div>
      </div>
      <div class="row">
        <div class="label">Call history</div>
        <div class="data">
          <textarea type="date" name="call_history" class="inpt" v-model="form.call_history" placeholder="Call history"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="label">Provider Of</div>
        <div class="data">
          <div class="check-item-row">
            <div 
              class="check-item-col" 
              v-for="(service, i) in providedServices"
              :key="i"
            >
              <div class="check-item-wrap">
                <label class="check-item-label">
                  <input
                    type="checkbox"
                    :value="service"
                    v-model="form.services"
                    :true-value="[]"
                    name="services"
                    class="chec-item"
                  />
                  {{ service }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row_files">
        <div class="box box_addFiles">
          <div v-if="getUploadedFiles('read_ai_history').length" class="content content_many">
            <draggable v-model="upload.read_ai_history" tag="div" class="draggable">
            <div v-for="(file, key) in getUploadedFiles('read_ai_history')" :key="key" class="file">
              <BlueFile class="img" />
              <div class="btn btn_del" @click="delFile('read_ai_history', key, file)"><Close class="img" /></div>
              <div class="btn btn_download" v-if="file.id" v-on:click.stop.prevent="downloadFile(file, 'read_ai_history')"><BlueDownload class="img" /></div>
              <div class="desc">{{ file.name }}</div>
            </div>
            </draggable>
            <div class="add">
              <div class="btn" @click="$refs.read_ai_history[upload.read_ai_history.length - 1].click()"><Close class="img" /></div>
            </div>
          </div>
          <div v-else class="content">
            <div class="choose">
              <div class="btn" @click="$refs.read_ai_history[0].click()">Read Ai History</div>
            </div>
          </div>
            <input
              v-for="(i, key) in upload.read_ai_history"
              :key="key"
              type="file"
              :name="`read_ai_history_${key}`"
              class="hide"
              ref="read_ai_history"
              @change="addInput($event, 'read_ai_history', key)"
            >
        </div>
        <div class="box box_addFiles">
          <div v-if="getUploadedFiles('provider_offer').length" class="content content_many">
            <draggable v-model="upload.provider_offer" tag="div" class="draggable">
            <div v-for="(file, key) in getUploadedFiles('provider_offer')" :key="key" class="file">
              <BlueFile class="img" />
              <div class="btn btn_del" @click="delFile('provider_offer', key, file)"><Close class="img" /></div>
              <div class="btn btn_download" v-if="file.id" v-on:click.stop.prevent="downloadFile(file, 'provider_offer')"><BlueDownload class="img" /></div>
              <div class="desc">{{ file.name }}</div>
            </div>
            </draggable>
            <div class="add">
              <div class="btn" @click="$refs.provider_offer[upload.provider_offer.length - 1].click()"><Close class="img" /></div>
            </div>
          </div>
          <div v-else class="content">
            <div class="choose">
              <div class="btn" @click="$refs.provider_offer[0].click()">Provider Offer</div>
            </div>
          </div>
            <input
              v-for="(i, key) in upload.provider_offer"
              :key="key"
              type="file"
              :name="`provider_offer_${key}`"
              class="hide"
              ref="provider_offer"
              @change="addInput($event, 'provider_offer', key)"
            >
        </div>
        <div class="box box_addFiles">
          <div v-if="getUploadedFiles('provider_agreement').length" class="content content_many">
            <draggable v-model="upload.provider_agreement" tag="div" class="draggable">
            <div v-for="(file, key) in getUploadedFiles('provider_agreement')" :key="key" class="file">
              <BlueFile class="img" />
              <div class="btn btn_del" @click="delFile('provider_agreement', key, file)"><Close class="img" /></div>
              <div class="btn btn_download" v-if="file.id" v-on:click.stop.prevent="downloadFile(file, 'provider_agreement')"><BlueDownload class="img" /></div>
              <div class="desc">{{ file.name }}</div>
            </div>
            </draggable>
            <div class="add">
              <div class="btn" @click="$refs.provider_agreement[upload.provider_agreement.length - 1].click()"><Close class="img" /></div>
            </div>
          </div>
          <div v-else class="content">
            <div class="choose">
              <div class="btn" @click="$refs.provider_agreement[0].click()">Provider Partner Agreement</div>
            </div>
          </div>
            <input
              v-for="(i, key) in upload.provider_agreement"
              :key="key"
              type="file"
              :name="`provider_agreement_${key}`"
              class="hide"
              ref="provider_agreement"
              @change="addInput($event, 'provider_agreement', key)"
            >
        </div>
      </div>
    </div>
    <div class="modal__footer">
      <div class="btn" @click="save">Save</div>
    </div>
  </div>
</template>

<script>
import Close from '../img/Close.vue'
import Tmblr from '../elem/Tmblr.vue'
import BlueFile from '../img/BlueFile.vue'
import draggable from 'vuedraggable'
import BlueDownload from '../img/BlueDownload.vue'

export default {
  components: {
    Close,
    Tmblr,
    BlueDownload,
    BlueFile,
    draggable,
  },
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data(){
    return{
      countries: [],
      managers: [],
      statuses: [
        'Send Letter',
        'No Respond',
        '1st Call',
        '2nd Call',
        '3rd Call',
        'Respond By Letter',
        'Get Offer',
        'Added to Provider',
      ],
      form: {
        managers: [],
        manager_name: null,
        status: null,
        country_id: null,
        company_name: null,
        service_type: null,
        provider_type: null,
        channel: null,
        web_site: null,
        contact_data: null,
        email: null,
        linkedin: null,
        price: null,
        first_message_status: null,
        first_call_date: null,
        call_history: null,
        approve_to_list: false,
        approve_to_legal_services_list: false,
        other_contact_person: null,
        services: [],
      },
      providedServices: [
        'Ready',
        'Scratch',
        'Account',
        'Hr'
      ],
      upload: {
        read_ai_history: [{ name: null }],
        provider_offer: [{ name: null }],
        provider_agreement: [{ name: null }],
      },
      error: null,
    }
  },
  computed: {
    isEdit () {
      return this.options && this.options.id && this.options.form
    }
  },
  async created () {
    if(this.isEdit){
      await this.getLeadContact()
      await this.updateFormData()
      await this.getReadAiHistory()
      await this.getProviderOffer()
      await this.getProviderAgreement()
    }

    await this.getCountries()
    await this.getManagers()
  },
  methods: {
    addManager(){
      this.form.managers.push({
        name: null
      })
    },
    deleteManager(index){
      this.form.managers.splice(index, 1)
    },
    updateFormData(){
      let arrManagers = [];
      
      if(this.form.manager_name){
        arrManagers = this.form.manager_name.split('|').map(name => {
          return { name: name };
        });
      }
      
      if(this.form.business_offer_id){
        this.$set(this.form, 'approve_to_list',  true)
      } else{
        this.$set(this.form, 'approve_to_list',  false)
      }
      
      if(this.form.legal_service_id){
        this.$set(this.form, 'approve_to_legal_services_list',  true)
      } else{
        this.$set(this.form, 'approve_to_legal_services_list',  false)
      }
      
      this.$set(this.form, 'managers',  arrManagers)
    },
    async getReadAiHistory() {
      const that = this
      const id = this.options.id
      
      if(id){
        await axios.get('admin/lead-contacts/' + id + '/get-file/read_ai_history')
        .then((response) => {
          let docsData = response.data
    
          if(docsData.length > 0) {
            that.upload.read_ai_history = docsData.map((el) => {
              return {
                id: el.id,
                uuid: el.uuid,
                name: el.name,
                type: 'server',
                url: el.original_url,
                order: el.order
              }
            })
          }
        })
        .catch((errors) => {
          console.dir(errors)
        })
      }
    },
    async getProviderOffer() {
      const that = this
      const id = this.options.id
      
      if(id){
        await axios.get('admin/lead-contacts/' + id + '/get-file/provider_offer')
        .then((response) => {
          let docsData = response.data
    
          if(docsData.length > 0) {
            that.upload.provider_offer = docsData.map((el) => {
              return {
                id: el.id,
                uuid: el.uuid,
                name: el.name,
                type: 'server',
                url: el.original_url,
                order: el.order
              }
            })
          }
        })
        .catch((errors) => {
          console.dir(errors)
        })
      }
    },
    async getProviderAgreement() {
      const that = this
      const id = this.options.id
      
      if(id){
        await axios.get('admin/lead-contacts/' + id + '/get-file/provider_agreement')
        .then((response) => {
          let docsData = response.data
    
          if(docsData.length > 0) {
            that.upload.provider_agreement = docsData.map((el) => {
              return {
                id: el.id,
                uuid: el.uuid,
                name: el.name,
                type: 'server',
                url: el.original_url,
                order: el.order
              }
            })
          }
        })
        .catch((errors) => {
          console.dir(errors)
        })
      }
    },
    getUploadedFiles(el) {
      return this.upload[el].filter(e => e.name !== null)
    },
    delFile(name, key, file) {
      if (this.upload[name].length > 1) {
        this.upload[name].splice(key, 1)
      } else {
        this.upload[name][0].name = null
      }
    
      if(file.id && this.options.id){
        axios.post('admin/lead-contacts/' + this.options.id +'/delete-file', {
        collection: name,
        media_id: file.id,
      })
        .then(function () {
          
        })
        .catch(function (error) {
          console.log(error);
        })
      }
    },
    addInput(event, name, key) {
      if (this.$refs[name][key].files.length) {
        const file_name = this.$refs[name][key].files[0].name
        if (this.getUploadedFiles(name).some(e => e.name == file_name)) {
          this.$noty.error('Error! A file with this name has already been added.')
          return false
        }
    
        const extension = this.$refs[name][key].files[0].name.split('.').pop()
        const availableExtensionsArr = ['jpg', 'jpeg', 'png', 'txt', 'pdf', 'doc', 'docx', 'xlsx']
        if (!availableExtensionsArr.includes(extension.toLowerCase())) {
          this.$noty.error('You can upload files only with these extensions: ' + availableExtensionsArr.join(', '))
          return false
        }
    
        if (this.$refs[name][key].files[0].size / 1024 / 1024 > 10) {
          this.$noty.error('File is too large. Maximum - 10MB.')
          return false
        }
    
        this.upload[name] = this.upload[name].filter(e => e.name !== null)
        if (this.$refs[name].length < 10) {
          this.upload[name].push({ name: file_name, file: event.target.files[0]})
        } else {
          this.$noty.error('Maximum - 10 files')
        }
      }
    },
    downloadFile(file, type) {
      const id = this.options.id
      if(file.url){
        this.openFile(file.url)
      }
      else if(id){
        axios.post('admin/lead-contacts/' + id +'/get-file-link', {
        collection: type,
        media_id: file.id,
      })
        .then(function (response) {
          if (response.data) {
            const url = response.data
            var fileURL = response.data;
            this.openFile(fileUrl);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
      }
    },
    processFiles(id){
      let data = new FormData()
      const uploadKeys = Object.keys(this.upload)
    
      for (let z = 0; z < uploadKeys.length; z++) {
        const key = uploadKeys[z]
        for (let i = 0; i < this.upload[key].length; i++) {
          if (this.upload[key][i].name !== null) {
            let f = {}
            if (this.upload[key][i].type == 'server') {
              f = JSON.stringify(this.upload[key][i])
            } else {
              data.append(key + '_names[' + i + ']', this.upload[key][i].name)
              f = this.upload[key][i].file
            }
            data.append(key + '[' + i + ']', f)
          }
        }
      }
      
      axios.post('admin/lead-contacts/' + id + '/files', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }).then((response) => {
        this.close()
      })
      .catch((errors) => {
        console.dir(errors)
      })
    },
    openFile(url){
      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.setAttribute('target', '_blank')
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async getLeadContact(){
      const that = this
      await axios.get('admin/lead-contacts/' + this.options.id)
      .then(function (response) {
        that.form = response.data
      })
      .catch(function (error) {
        console.log(error);
      })
	  },
    async getCountries () {
      await axios.get('admin/data/countries')
      .then(({data}) => {
        this.countries = data
      })
      .catch((error) => {
        console.log(error);
      })
    },
    async getManagers () {
      const that = this
      await axios.get('admin/data/managers')
        .then(function (response) {
          that.managers = response.data
        })
        .catch(function (error) {
          console.log(error);
        })
	  },
    async save(){
      let url = process.env.VUE_APP_BACKEND_API_URL + 'admin/lead-contacts'

      if (this.isEdit) {
        url += '/' + this.options.id
      }

      this.form.manager_name = this.form.managers.map(obj => obj.name).join('|');

      await axios.post(url, this.form)
        .then((response) => {
          this.close();
          
          this.processFiles(response.data.leadContact.id);

          if(this.isEdit){
            this.$store.dispatch('editItemFromTable', {
              id: this.options.id,
              table: this.options.table,
              actionType: this.options.actionType,
            })
          }
          else{
            this.$store.dispatch('createItemInTable', {
              table: this.options.table,
              actionType: this.options.actionType,
            })
          }
        })
        .catch((errors) => {
          console.dir(errors)
        })
    },
    changeState(property){
      if(property == 'approve_to_list' && this.form.business_offer_id){
        return '';
      }
      
      if(property == 'approve_to_legal_services_list' && this.form.legal_service_id){
        return '';
      }
      
      this.form[property] = !this.form[property]
    },
    close() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &__wrapper {
    width: 40rem;
  }

  &__header {
    padding: 2.5rem 0.75rem 1.5rem;
  }

  &__body {
    flex-direction: column;
    align-content: flex-start;

    .row {
      width: 100%;
      display: flex;
      align-items: center;
      padding: .25rem 0;
      margin: .25rem 0 0;

      .label {
        min-width: 10rem;
        padding-right: .75rem;
        font-weight: bold;
        max-width: 160px;
      }

      .data {
        flex-grow: 1;

        .inpt {
          width: 100%;
          color: #000000;

          &__ta {
            height: 7rem;
          }
        }
        .btn {
          padding: 0.5rem;
          background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
          border-radius: 6px;
          color: #fff;
          font-size: 13px;
        }
        .delete-btn{
          margin-left: auto;
          width: 24px;
          height: 24px;
          background-color: #B03636;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          svg{
            fill: #fff;
            max-width: 16px;
            max-height: 16px;
          }
        }
      }

      &__price {
        .data {
          display: flex;

          input {
            margin-right: .75rem;
          }

          select {
            color: white;
            background-color: var(--c_more-black);
            padding: .25rem .5rem;
            border-radius: 6px;
          }
        }
      }
    }
    .row{
      &_files {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 8px;

        .box_addFiles {
          width: 30%;
          //width: calc(50% - .75rem);
          //margin: .75rem 0;
          //padding: 1rem 1.75rem;
          //background: #22252B;
          box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
          display: flex;
          flex-direction: column;

          .ttl {
            padding-bottom: .25rem;
          }

          .separ {
            width: 3rem;
            height: .25rem;
            background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
            box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
            border-radius: 14px;
            margin: .25rem 0;
          }

          .content {
            padding: 1rem;
            flex-grow: 1;
            //margin-top: 1rem;
            border: 1px dashed #1763fb;
            box-sizing: border-box;
            filter: drop-shadow(0px 12px 23px rgba(62, 73, 84, 0.04));
            border-radius: 14px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .choose {
              text-align: center;

              .btn {
                padding: 0.5rem;
                background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                border-radius: 6px;
                color: #fff;
                font-size: 13px;
              }

              .desc {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.3);
              }
            }

            &_many {
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: space-between;
              padding: 0.75rem 6px;

              .draggable {
                display: flex;
                padding: 0;
                flex-wrap: wrap;
              }

              .file {
                position: relative;
                text-align: center;
                width: 4.5rem;
                max-width: 4.5rem;

                svg.img {
                  width: 3rem;
                  height: 3rem;
                  margin: 0 auto;
                  cursor: pointer;
                  fill: #1763fb;
                  path{
                    fill: #1763fb;
                  }
                }
                .btn {
                  &_del {
                    position: absolute;
                    top: 0;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    background-color: #B03636;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 40%;
                      height: 40%;
                    }
                  }

                  &_download {
                    position: absolute;
                    top: 1.7rem;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 90%;
                      height: 90%;
                    }
                  }
                }

                .desc {
                  font-size: 10px;
                  color: #333333;
                  word-break: break-word;
                }
              }

              .add {
                text-align: center;
                width: 2.5rem;
                max-width: 2.5rem;

                .btn {
                  width: 2.5rem;
                  height: 2.5rem;
                  border-radius: 50%;
                  background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  svg.img {
                    width: 45%;
                    height: 45%;
                    transform: rotate(45deg);
                  }
                }

                .desc {
                  font-size: 12px;
                  color: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }
    }
  }
  &__footer {
    padding: 1rem 1.5rem 1.5rem;
  }
  textarea{
    height: 5rem;
  }
}
.check-item{
  &-row{
    display: flex;
    max-width: 100%;
    width: 100%;
    gap: 12px;
  }
  &-col{
    flex: 0 0 auto;
    max-width: 100%;
  }
  &-label{
    font-size: 16px;
    color: #000;
  }
}
.gap-12{
  gap: 12px;
}
</style>
